export const enum GiftingDesignationTypes {
  VANGUARD = 'VANGUARD',
  NON_VANGUARD = 'NON_VANGUARD',
  EMPTY = '',
}
